import styled from 'styled-components';

const HeaderLogo = styled.div`
	display: inline-block;
	width: 58px;
	height: 48px;
	display: flex;
	align-items: center;
	background: url(${require('../../assets/images/logo.png')});
	background-size: cover;
	margin-right: 35px;
`;

export default HeaderLogo;
